export default { name: '@auth0/auth0-angular', version: '1.11.1' };
